import {cs}                from "@Common/react/chain-services";
import {scopedState}       from "@Common/react/scoped-state";
import {UseState}          from "@Common/react/use-state";
import {setCurrentToSaved} from "@Common/ui-components/heavy/item-options/modules/set-current-to-saved";
import {changeNestedValue} from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";

export const ItemNameLogic = (
    {
        item,
        getDefaultValue,
        next,
    }
) => cs(
    ["state", (_, next) => UseState({
        getInitValue: () => chain(
            item?.itemName || getDefaultValue(),
            (_) => ({
                saved  : _,
                current: _,
            }),
        ),
        next,
    })],
    ({state}) => next({
        ui: {
            state: scopedState(state, ["current"]),
        },
        itemEditor: {
            $name: "item name",
            prepareSave: (item) => ({
                newValue: changeNestedValue(item, ["itemName"], (_) => state.value.current),
                onSaved: () => setCurrentToSaved(state),
            }),
            changed: state.value.saved !== state.value.current,
            valid: state.value.current,
        },
    }),
);